import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import AdminTable from "./components/RoleTable";
import AddSubAdminForm from "./components/AddSubAdminForm";

const RoleManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <div className="p-4">
      {/* Header */}
      <div className="mb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <h1 className="text-xl font-bold text-gray-800 dark:text-white">
          Role Management
        </h1>

        <div className="flex flex-wrap gap-3">
          {/* Search */}
          <div className="relative">
            <input
              type="text"
              placeholder="Search roles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="rounded border px-3 py-2 pr-10 text-sm outline-none dark:bg-navy-700 dark:text-white"
            />
            <FaSearch className="absolute right-3 top-2.5 text-gray-500" />
          </div>

          {/* Add Button */}
          <button
            onClick={() => setShowAddModal(true)}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded text-sm font-medium"
          >
            + Add Sub Admin
          </button>
        </div>
      </div>

      {/* Admin Table */}
      <AdminTable searchTerm={searchTerm} />

      {/* Add Modal */}
      {showAddModal && (
        <AddSubAdminForm onClose={() => setShowAddModal(false)} />
      )}
    </div>
  );
};

export default RoleManagement;
